/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { useRoomsCountSelectorProps } from './utils/roomsCountSelector/useRoomsCountSelectorProps';
import { useAreaInputProps } from './utils/useAreaInputProps';
import { useAddressProps } from './utils/addressProps/useAddressProps';
import { useEstimationTargetProps } from './utils/useEstimationTargetProps';
import { Layout } from '../../components/Layout';
import { useJkRoomsCountSelectorProps } from './utils/jkRoomsCountSelector/useJkRoomsCountSelectorProps';
import { Provider } from '../../context/widgetContext';
import { useHouseAreaInputProps } from './utils/useHouseAreaInputProps';
import { useLandAreaInputProps } from './utils/useLandAreaInputProps';
import { jsx as _jsx } from "react/jsx-runtime";
export var MainFiltersWidget = function MainFiltersWidget(_ref) {
  var targetPage = _ref.targetPage,
      isWebview = _ref.isWebview,
      isEmbedded = _ref.isEmbedded;
  var isDesktop = useIsDesktop();
  var roomsCountSelectorProps = useRoomsCountSelectorProps();
  var jkRoomsCountSelectorProps = useJkRoomsCountSelectorProps();
  var areaProps = useAreaInputProps();
  var houseAreaProps = useHouseAreaInputProps();
  var landAreaProps = useLandAreaInputProps();
  var addressProps = useAddressProps({
    targetPage: targetPage,
    isDesktop: isDesktop
  });
  var estimationTargetProps = useEstimationTargetProps();
  return /*#__PURE__*/_jsx(Provider, {
    value: {
      isDesktop: isDesktop,
      targetPage: targetPage,
      isWebview: isWebview
    },
    children: /*#__PURE__*/_jsx(Layout, {
      areaProps: areaProps,
      houseAreaProps: houseAreaProps,
      landAreaProps: landAreaProps,
      roomsCountSelectorProps: roomsCountSelectorProps,
      addressProps: addressProps,
      estimationTargetProps: estimationTargetProps,
      jkRoomsCountSelectorProps: jkRoomsCountSelectorProps,
      isEmbedded: isEmbedded
    })
  });
};
MainFiltersWidget.displayName = 'MainFiltersWidget';